import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import SalePackages from '../../SalePackagesBlock/SalePackages';
import FamilyStatus from '../../../Shared/FamilyStatus/FamilyStatus';
import {gtag4} from '../../../../utilities/analytics/tracking';

const SelectCellularPackageComponent = (props) => {
  useEffect(() => {
    const gaParam = props.discountedPackage != null ? 'הוצגה תוכנית מיוחדת' : 'הוצגו תוכניות רגילות בלבד';
    if (props.limited) {
      gaEvent(
        gaParams.CHANGE_PRICE_PLAN_SELECTING_NEW_PLAN_PAGE_FOR_LIMITED.category,
        gaParams.CHANGE_PRICE_PLAN_SELECTING_NEW_PLAN_PAGE_FOR_LIMITED.eventType,
        gaParam
      );
    } else {
      gaEvent(
        gaParams.CHANGE_PRICE_PLAN_SELECTING_NEW_PLAN_PAGE.category,
        gaParams.CHANGE_PRICE_PLAN_SELECTING_NEW_PLAN_PAGE.eventType,
        gaParam
      );
    }
    if (!props.startedFromPackage) {
      gtag4({
        event: 'CellPackUpdateP2_Step5a_PackageImp',
        step: '5a',
        title: getTitle(),
        action: 'PackageImp',
      });
    }
  }, []);

  function getTitle() {
    let title;
    if (props.titleReselectPackage) {
      title = props.titleReselectPackage;
    } else {
      title =
        props.discountedPackage != null || props.familyPackages?.length > 0 ? 'עוד תוכניות שיש לנו להציע' : 'מה תהיה החבילה הבאה שלכם';
    }
    return title;
  }

  return (
    <div className={` ${isMobile ? 'pl-0 pr-0' : ''} m-auto cellular-holder`}>
      {props.familyPackages && (
        <>
          {/* {isMobile && <FamilyStatus balance={props.balance} used={props.used} isAllowed={props.isAllowed} />} */}
          <div className='bold cellular-package-description text-center mb-0'>
            חבילות מיוחדות לעובדי <br /> {props.organizationName}
          </div>
          {/* {!isMobile && <FamilyStatus balance={props.balance} used={props.used} isAllowed={props.isAllowed} />} */}
          <div className='packages-wrapper family'>
            <SalePackages
              packages={props.familyPackages}
              onSelectedPackages={(newPackage) => props.orderEvent(newPackage)}
              oneTimeFee={true}
              isChangePricePlan={true}
            />
          </div>
        </>
      )}
      {props.discountedPackage != null && (
        <div className={`m-auto pr-0 pl-0`}>
          <p className='bold cellular-package-description text-center mb-0'>הצעה מיוחדת ללקוחות הנייח של {window.Config.brand_Name_HE}!</p>
          <SalePackages
            packages={{expandedValue: [props.discountedPackage]}}
            onSelectedPackages={(newPackage) => props.orderEvent(newPackage)}
            oneTimeFee={true}
            isChangePricePlan={true}
          />
        </div>
      )}
      {props.packages?.expandedValue?.length > 0 && (
        <>
          <div>
            <p className='bold cellular-package-description text-center mb-0' dangerouslySetInnerHTML={{__html: getTitle()}} />
          </div>
          <div className='packages-wrapper'>
            <SalePackages
              packages={props.packages}
              onSelectedPackages={(newPackage) => props.orderEvent(newPackage)}
              oneTimeFee={true}
              isChangePricePlan={true}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default SelectCellularPackageComponent;
